/**
 * Alle Vorlagen in der Reihenfolge der Galerie.
 */
import type { AnimationTemplate } from '../template.ts';
import { bakeBakeTemplate } from './bake-bake.ts';
import { bakeBrushTemplate } from './bake-brush.ts';
import { bakeCoolTemplate } from './bake-cool.ts';
import { bakeCutOutTemplate } from './bake-cut-out.ts';
import { bakeFillTemplate } from './bake-fill.ts';
import { bakeGlazeTemplate } from './bake-glaze.ts';
import { bakeGreaseTemplate } from './bake-grease.ts';
import { bakePizzaOvenTemplate } from './bake-pizza-oven.ts';
import { bakePrickTemplate } from './bake-prick.ts';
import { bakeProofTemplate } from './bake-proof.ts';
import { bakeRollTemplate } from './bake-roll.ts';
import { bakeSkewerTemplate } from './bake-skewer.ts';
import { bakeTopTemplate } from './bake-top.ts';
import { cutChopTemplate } from './cut-chop.ts';
import { cutCoreTemplate } from './cut-core.ts';
import { cutDiceTemplate } from './cut-dice.ts';
import { cutGrateTemplate } from './cut-grate.ts';
import { cutPeelTemplate } from './cut-peel.ts';
import { cutSliceTemplate } from './cut-slice.ts';
import { cutStripsTemplate } from './cut-strips.ts';
import { mixAddTemplate } from './mix-add.ts';
import { mixBeatTemplate } from './mix-beat.ts';
import { mixBlendTemplate } from './mix-blend.ts';
import { mixCreamTemplate } from './mix-cream.ts';
import { mixFoldTemplate } from './mix-fold.ts';
import { mixKneadTemplate } from './mix-knead.ts';
import { mixPourTemplate } from './mix-pour.ts';
import { mixSiftTemplate } from './mix-sift.ts';
import { mixStirTemplate } from './mix-stir.ts';
import { preheatOvenTemplate } from './preheat-oven.ts';
import { prepBreadTemplate } from './prep-bread.ts';
import { prepChillTemplate } from './prep-chill.ts';
import { prepMarinateTemplate } from './prep-marinate.ts';
import { prepMeasureTemplate } from './prep-measure.ts';
import { prepPlateTemplate } from './prep-plate.ts';
import { prepPoundTemplate } from './prep-pound.ts';
import { prepRestTemplate } from './prep-rest.ts';
import { prepSeasonTemplate } from './prep-season.ts';
import { prepSeparateEggsTemplate } from './prep-separate-eggs.ts';
import { prepShapeTemplate } from './prep-shape.ts';
import { prepSqueezeTemplate } from './prep-squeeze.ts';
import { prepWashTemplate } from './prep-wash.ts';
import { prepWeighTemplate } from './prep-weigh.ts';
import { stoveBainMarieTemplate } from './stove-bain-marie.ts';
import { stoveBoilTemplate } from './stove-boil.ts';
import { stoveDeepFryTemplate } from './stove-deep-fry.ts';
import { stoveDeglazeTemplate } from './stove-deglaze.ts';
import { stoveDrainTemplate } from './stove-drain.ts';
import { stoveFlipTemplate } from './stove-flip.ts';
import { stoveHeatFatTemplate } from './stove-heat-fat.ts';
import { stoveMeltTemplate } from './stove-melt.ts';
import { stoveSearTemplate } from './stove-sear.ts';
import { stoveSetHeatTemplate } from './stove-set-heat.ts';
import { stoveSimmerTemplate } from './stove-simmer.ts';
import { stoveSweatTemplate } from './stove-sweat.ts';
import { whiskStiffTemplate } from './whisk-stiff.ts';

export const ALL_TEMPLATES: readonly AnimationTemplate[] = [
  // Schneiden
  cutDiceTemplate,
  cutSliceTemplate,
  cutStripsTemplate,
  cutChopTemplate,
  cutPeelTemplate,
  cutGrateTemplate,
  cutCoreTemplate,
  // Mischen
  mixPourTemplate,
  mixAddTemplate,
  mixStirTemplate,
  mixBeatTemplate,
  whiskStiffTemplate,
  mixCreamTemplate,
  mixFoldTemplate,
  mixKneadTemplate,
  mixSiftTemplate,
  mixBlendTemplate,
  // Herd
  stoveSetHeatTemplate,
  stoveHeatFatTemplate,
  stoveBoilTemplate,
  stoveSimmerTemplate,
  stoveSearTemplate,
  stoveSweatTemplate,
  stoveFlipTemplate,
  stoveDrainTemplate,
  stoveDeglazeTemplate,
  stoveBainMarieTemplate,
  stoveMeltTemplate,
  stoveDeepFryTemplate,
  // Backen
  preheatOvenTemplate,
  bakePizzaOvenTemplate,
  bakeGreaseTemplate,
  bakeFillTemplate,
  bakeTopTemplate,
  bakeBrushTemplate,
  bakeBakeTemplate,
  bakeRollTemplate,
  bakeCutOutTemplate,
  bakePrickTemplate,
  bakeProofTemplate,
  bakeSkewerTemplate,
  bakeCoolTemplate,
  bakeGlazeTemplate,
  // Vorbereiten & Anrichten
  prepWeighTemplate,
  prepMeasureTemplate,
  prepSeparateEggsTemplate,
  prepWashTemplate,
  prepSqueezeTemplate,
  prepPoundTemplate,
  prepBreadTemplate,
  prepMarinateTemplate,
  prepSeasonTemplate,
  prepShapeTemplate,
  prepRestTemplate,
  prepChillTemplate,
  prepPlateTemplate,
];
